<div (click)="routeToNetzzuordnungPage()" fxLayout="row" fxLayoutGap="1rem" style="cursor: pointer">
    <div data-qa="messages" fxFlex="7" fxLayout="column" fxLayoutAlign="space-around stretch">
        <img mat-card-sm-image src="/assets/eon-pictograms/digitalisation.svg">
    </div>

    <div data-qa="messages" fxFlex="60" fxLayout="column" fxLayoutAlign="space-around stretch">
        <p>Seit ihrer letzten Kenntnisnahme ({{ lastConfirmedUuidDate | date:'dd.MM.yyyy' }}
            um {{ lastConfirmedUuidDate | date:'HH:mm' }}) gibt
            es {{ (numberOfUnconfirmedNetzzuordnungen) }} neue/geänderte
            UUID's. Bitte bestätigen Sie Ihre Kenntnisname über den Kenntnisnahme-Button.
            Über den Button "Netzzuordnungen" können sie sich die neuen/geänderten UUID's anzeigen
            und exportieren lassen.
        </p>
    </div>

    <div class="notify-badge" data-qa="link" fxFlex="33" fxLayoutAlign="center center">
        <div class="badge-text">Jetzt bestätigen</div>
    </div>
</div>
